import { days, DayOfWeek } from 'core/day-of-week';

export const orderedDays = days(DayOfWeek.Sunday);
